import { render, staticRenderFns } from "./TopicStaticContent.vue?vue&type=template&id=50abbbf6&scoped=true"
import script from "./TopicStaticContent.vue?vue&type=script&lang=js"
export * from "./TopicStaticContent.vue?vue&type=script&lang=js"
import style0 from "./TopicStaticContent.vue?vue&type=style&index=0&id=50abbbf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50abbbf6",
  null
  
)

export default component.exports